import axios from '../../axios';
import * as actionTypes from "./actionTypes";

export const Topics = {
    CHOOSING_AN_OFFER_KEY: 1,
    getList: () => [
        { key: Topics.CHOOSING_AN_OFFER_KEY, name: "Choosing an Offer" },
        { key: 2, name: "Setting an Appointment" },
        { key: 3, name: "Adding Another Vehicle" },
        { key: 4, name: "General Question" },
        { key: 5, name: "Other" }
    ]
};

export const resetMessage = () => {
    return async (dispatch, getState) => {
        dispatch({data: null, type: actionTypes.SET_MESSAGE_RESET})
    }
}

export const setMessageLoading = (loading) => {
    loading = !!loading;
    return {
        type: actionTypes.SET_MESSAGE_LOADING,
        loading
    };
}
export const setOpenMessagesModal = (isOpen, selectedTopic) => {
    return {
        type: actionTypes.SET_MESSAGE_OPEN,
        isOpen,
        selectedTopic
    };
}

export const openMessageModal = (selectedTopic) => {
    return async (dispatch, getState) => {
        dispatch({data: null, type: actionTypes.SET_MESSAGE_RESET})
        dispatch(setOpenMessagesModal(true, selectedTopic))

    }
}

export const setMessageError = (error) => {
    return {
        type: actionTypes.SET_MESSAGE_ERROR,
        error
    };
};

export const sendMessage = (subject, message, cb = null) => {
    return async (dispatch, getState) => {
        dispatch(setMessageLoading(true));
        const onError = (err) => {
            dispatch(setMessageLoading(false));
            dispatch(setMessageError(err))
        };

        const token = getState().auth.token.id_token;
        try {
            const res = await axios.post(`messages`, {
                'subject': subject,
                'text': message
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            });
            if (res.data && res.data.error) {
                throw new Error(res.data.error);
            }
            dispatch(setMessageLoading(false));
            cb && cb();

        } catch (err) {
            onError(err.message);
        }
    }
};
